module.exports = __webpack_public_path__ + "static/automation-f611d747c19ca95e8119a53bb846a935.jpg";